// extracted by mini-css-extract-plugin
export default {"TextAreaElementContainer":"TextAreaElement-module__TextAreaElementContainer--pzfPW","codeViewTextArea":"TextAreaElement-module__codeViewTextArea--kzP8v"};